<template>
    <q-modal v-model="showLogin" :no-esc-dismiss="true"  :no-backdrop-dismiss="true" :content-css="{'background-color': '#222'}" class="padding-modal bg-dark">
        <div class="layout-padding bg-dark">
            <!--<div class="modal-close">-->
                <!--<q-btn color="primary" round dense icon="close" @click="showLogin = false;$router.push('/')"></q-btn>-->
            <!--</div>-->

            <div class="q-py-lg">

                <template v-if="!user">
                    <!-- <form @submit.prevent="login(slug)"
                          class="gutter-xs"
                          @keydown="form.onKeydown($event)">

                        <div class="text-center"><img src="../../../img/identity/p4f.svg" width="50%"/>
                        </div>

                        <div class="row justify-center">
                            <v-submit :label="$t('log in')"
                                      :loadingLabel="$t('validating...')"
                                      color="primary"
                                      :form="form">
                            </v-submit>
                        </div>
                    </form>

                    <template slot="actions">
                        <q-btn flat color="highlight" @click="$router.push({ name: 'password.request' })"
                              :label="$T('forgot your password?')"></q-btn>
                    </template> -->
                </template>

                <div v-else class="text-center">
                    <div v-if="user.subscription_status==150">
                        <form @submit.prevent="redirectToWapBilling()"
                              class="gutter-xs q-pa-xs"
                              @keydown="form.onKeydown($event)">

                            <div class="text-center">
                              <img src="../../../img/identity/logo-pocket.png" /><br>
                              <img id="age-verification-image" src="../../../img/identity/age_verification.gif">
                            </div>
                            <div v-html="suspendMessage" class="text-white"></div>
                            <!-- Submit Button -->
                            <div class="row justify-center">
                              
                            </div>

                        </form>

                    </div>
                    <template v-else>

                        {{ $T('you are logged in!') }}
                    </template>
                </div>

            </div>
        </div>
    </q-modal>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "vform";
import axios from "axios";
import {
  QModal,
  QSpinnerPuff,
  QBtn,
  QCheckbox,
  QInput,
  Cookies
} from "quasar-framework";

export default {
  name: "VSuspended",
  components: {
    QModal,
    QBtn,
    QSpinnerPuff,
    QCheckbox,
    QInput
  },

  data: () => ({
    form: new Form({
      email: "go4@test.com",
      password: "secret",
      remember: false,
      redirectTo: this.slug
    }),
    suspendMessage: "",
    portalId: ""
  }),

  computed: {
    ...mapGetters({
      user: "auth/user",
      settings: "local/settings"
    }),
    showLogin: {
      get() {
        return this.settings("suspended");
      },
      set(value) {
        this.$store.dispatch("local/set", { key: "suspended", value });
      }
    },

    slug: {
      get() {
        return this.settings("redirect-route");
      },
      set(value) {
        this.$store.dispatch("local/set", { key: "redirect-route", value });
      }
    }
  },
  mounted() {
    this.portalId = Cookies.get('portal')
    this.getSuspendMessage();
  },
  methods: {
    redirectToWapBilling() {
      axios.get(`${config.appUrl}/api/service-url`).then(({ data }) => {
        window.location.href = data;
      });
    },
    getSuspendMessage() {
      axios.get(`${config.appUrl}/${this.portalId}/${this.user ? this.user.id : 'undefined'}/message`).then(({ data }) => {
        this.suspendMessage = data && data[0] ? data[0]['suspendMessage'] : '';
      });
    },
    async login(slug) {
      this.form.redirectTo = slug != undefined ? slug : "/";
      // Submit the form.
      const { data } = await this.form.post(`${config.appUrl}/api/login`);
      window.location.href = data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/suspended.vue